var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',{staticClass:"__picture",style:({'--a': _vm.aspect.toString()})},[_vm._l((_vm.sources),function(source,id){return _c('source',{key:id,attrs:{"media":source.media,"srcset":source.srcset,"type":source.type}})}),_vm._v(" "),_c('img',{attrs:{"src":_vm.defaultSrc}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }